import type { DuplicateParams } from '@/features/invoice_reports/components/ConfirmDuplicateModal/context/ConfirmDuplicateModalContext';
import { useCopyInvoiceReportService } from '@/context/services/invoice_reports/InvoiceReportCopy.service';
import { extractInvoiceReportErrorMessage } from '@/features/invoice_reports/utils/extractErrorMessage';
import { useTranslation } from '@/i18n';
import { useToastAPI } from '@moneyforward/ap-frontend-components';
import { useCallback } from 'react';

const TOAST_DURATION = 5;

export const useDuplicateInvoiceReport = () => {
  const notify = useToastAPI();
  const { t } = useTranslation();
  const { copyAsync } = useCopyInvoiceReportService();

  const duplicateReport = useCallback(
    (params: DuplicateParams) => async () => {
      if (!params.copyPath) return;

      try {
        await copyAsync(params.copyPath);
      } catch (error) {
        notify.error({
          title:
            extractInvoiceReportErrorMessage(error, t) ?? t('system_error'),
          duration: TOAST_DURATION,
        });
      }
    },
    [copyAsync, notify, t]
  );

  return {
    duplicateReport,
  };
};
